import React, {Component} from 'react';
import {authService} from "../../../auth";

import {connect} from "react-redux";

import OtherExperience from "../OtherProfile/OtherExperience";
import OtherJobAndAssignment from "../OtherProfile/OtherJobAndAssignment";
import OtherTraining from "../OtherProfile/OtherTraining";
import OtherEvents from "../OtherProfile/OtherEvents";
import OtherExperienceAndTrainingAll from "../OtherProfile/OtherExperienceAndTrainingAll";
import OtherExperienceTrainingEventsPopUp from "../OtherProfile/OtherExperienceTrainingEventsPopUp";
import HorizontalScroll from 'react-scroll-horizontal';
import {isMobileDevice} from "./../../../commons/CommonFunctions";
import OtherExpeditions from '../OtherProfile/OtherExpeditions';
import OtherStoryBooks from '../OtherProfile/OtherStoryBooks';
import OtherFundRaise from '../OtherProfile/OtherFundRaise';
if (isMobileDevice()) {
    import('./../../../commons/styles/responsive-useragent.css').then(() => {
       console.log("Imported mobile css");
    });
}


class UnAuthOtherExperienceTrainingEvents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            trainingPagination:false,
            training: [],
            trainingLength: 0,
            experienceLength: 0,
            eventLength: 0,
            allLength : 0,
            jobAndAssignmentLength: 0,
            eventPagination: false,
            events: [],
            allShow:false,
            onlyExperienceShow:true,
            expeditionLength: 0,
            storyBookLength: 0,
            fundRaiseLength: 0
        }
    }

    setTrainingLength = (length) => {
        this.setState({ 'trainingLength': length });
    }

    setEventLength = (length) => {
        this.setState({ 'eventLength': length });
    }

    setJobAndAssignmentLength = (length) => {
        this.setState({ 'jobAndAssignmentLength': length });
    }

    setAllLength = (length) => {
        this.setState({ 'allLength': length });
        if(length>0){
            this.setState({allShow:true,onlyExperienceShow:false});
        }
    }

    setExperienceLength = (length) => {
        this.setState({ 'experienceLength': length });
    }

    setExpeditionLength = (length) => {
        this.setState({ 'expeditionLength': length });
    }

    setStoryBookLength = (length) => {
        this.setState({"storyBookLength": length})
    }

    setFundRaiseLength = (length) => {
        this.setState({"fundRaiseLength": length})
    }


    render() {
        const parent  = { height: '40px'}
        return (
            <div className="profsectionwrap">
                <div className="profsectiondesc">
                    <div className="topbar">
                        <HorizontalScroll className="horizontalNav" style={parent} reverseScroll>
                            <ul id="tabs" className="nav">
                                    {/* {this.state.allLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-all"
                                                                    data-toggle="tab"
                                                                    className="nav-link active">Experience</a>
                                        </li>
                                    } */}

                                    {this.state.allLength === 0 ?
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-expierence"
                                                                    data-toggle="tab"
                                                                    className="nav-link active">Experience</a>
                                        </li> : 
                                        this.state.experienceLength>0 &&
                                            <li className="nav-item"><a href="javascript:void(0)"
                                                                        data-target="#other-prof-expierence"
                                                                        data-toggle="tab"
                                                                        className="nav-link">Experience</a>
                                            </li>
                                    }

                                    {/* {this.state.jobAndAssignmentLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                data-target="#other-prof-rrojects"
                                                                data-toggle="tab"
                                                                className="nav-link">Assignment</a>
                                    </li>}
                                    {this.state.trainingLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-training"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Training</a>
                                        </li>
                                    }
                                    {this.state.eventLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-events"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Events</a>
                                        </li>
                                    }
                                    {this.state.expeditionLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-expeditions"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Expedition</a>
                                        </li>
                                    }
                                    {this.state.storyBookLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-storybooks"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Storybook</a>
                                        </li>
                                    }
                                    {this.state.fundRaiseLength > 0 &&
                                        <li className="nav-item"><a href="javascript:void(0)"
                                                                    data-target="#other-prof-fundraises"
                                                                    data-toggle="tab"
                                                                    className="nav-link">Fund Raise</a>
                                        </li>
                                    } */}

                                </ul>
                        </HorizontalScroll>
                    </div>
                    <div id="tabsContent" className="tab-content">




                                <>
                                    <OtherExperience personalExperience={this.props.personalExperience} userId={this.props.userId} setExperienceLength={this.setExperienceLength} isShow={this.state.onlyExperienceShow}/>
                                   
                                    {/* <OtherJobAndAssignment setJobAndAssignmentLength={this.setJobAndAssignmentLength} userId={this.props.userId} />
                                    <OtherTraining setTrainingLength={this.setTrainingLength} userId={this.props.userId}/>
                                    <OtherEvents setEventLength={this.setEventLength} userId={this.props.userId}/>
                                    <OtherExperienceAndTrainingAll userId={this.props.userId} isShow={this.state.allShow} setAllLength={this.setAllLength}/>
                                    <OtherExpeditions  setExpeditionLength={this.setExpeditionLength} userId={this.props.userId} />
                                    <OtherStoryBooks setStoryBookLength={this.setStoryBookLength} userId={this.props.userId} />
                                    <OtherFundRaise setFundRaiseLength={this.setFundRaiseLength} userId={this.props.userId} /> */}
                                </>









                    </div>
                </div>
                <OtherExperienceTrainingEventsPopUp jobAndAssignmentLength={this.state.jobAndAssignmentLength}
                                                    trainingLength={this.state.trainingLength}
                                                    eventLength={this.state.eventLength}
                                                    personalExperience={this.props.personalExperience}
                                                    userId={this.props.userId}
                                                    allLength={this.state.allLength}
                                                    experienceLength={this.state.experienceLength}
                                                    storyBookLength={this.state.storyBookLength}
                                                    fundRaiseLength={this.state.fundRaiseLength}
                                                    expeditionLength={this.state.expeditionLength}
                />

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        personalExperience: state.ProfileReducer.personalExperience
    };
};


export default connect(mapStateToProps)(UnAuthOtherExperienceTrainingEvents);

